import { Close } from "@mui/icons-material";
import { Chip, Tooltip } from "@mui/material";
import { memo } from "react";

import { useQueryParams } from "../../../../hooks/useQueryParams";
import HNSColors from "../../../ui library/HNSColors";
import { MultiSelectDB, SingleSelectDB } from "../../CaseList/utils/store";

const DrawerFilterChips = ({
  activeFilters = [],
  queryParamsOptions = { replaceNavigation: true },
}) => {
  const { updateFilter, bulkUpdateFilters } = useQueryParams(queryParamsOptions);

  const handleChipDelete = async (filterConfig) => {
    if (["DateRange", "RangeSlider"].includes(filterConfig.filterType)) {
      bulkUpdateFilters([
        [filterConfig.fieldName + "__gte", null],
        [filterConfig.fieldName + "__lte", null],
      ]);
    } else if (filterConfig.filterType === "MultiSelectSearch") {
      bulkUpdateFilters([
        [filterConfig.fieldName, null],
        [filterConfig.fieldName + "__in", null],
      ]);
      await MultiSelectDB.delete(filterConfig.fieldName);
    } else {
      if (filterConfig.filterType === "SingleSelect") {
        await SingleSelectDB.delete(filterConfig.fieldName);
      }
      updateFilter(filterConfig.fieldName, null);
    }
  };

  if (activeFilters.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap w-full gap-2 mb-4">
      {activeFilters.map((filterConfig, index) => {
        const tooltipText = `${filterConfig.title}: ${filterConfig.activeChip.label}`;

        const customLabel = (
          <span className="inline-block max-w-[300px] truncate">
            <span style={{ fontWeight: 600 }}>{filterConfig.title}:</span>{" "}
            <span style={{ fontWeight: 400 }}>{filterConfig.activeChip.label}</span>
          </span>
        );

        return (
          <Tooltip
            title={tooltipText}
            arrow
            key={`${filterConfig.fieldName}-${index}`}
            slotProps={{
              popper: {
                modifiers: [
                  {
                    name: "offset",
                    options: {
                      offset: [0, -8],
                    },
                  },
                ],
              },
            }}
          >
            <Chip
              id={`actionable-items-filter-chip-${filterConfig.fieldName}-${index}`}
              className="max-w-[320px] px-2 text-center shadow-inner"
              onDelete={() => handleChipDelete(filterConfig)}
              deleteIcon={
                <Close
                  sx={{
                    fontSize: "18px",
                    color: HNSColors.secondary[400],
                    "&:hover": {
                      color: HNSColors.secondary[500],
                    },
                  }}
                />
              }
              label={customLabel}
              sx={{
                backgroundColor: HNSColors.secondary[900],
                color: HNSColors.secondary[400],
                borderRadius: "500px",
                "& .MuiChip-deleteIcon": {
                  color: HNSColors.secondary[400],
                  "&:hover": {
                    color: HNSColors.secondary[500],
                  },
                },
                "& .MuiChip-label": {
                  display: "flex",
                  alignItems: "center",
                },
              }}
            />
          </Tooltip>
        );
      })}
    </div>
  );
};

export default memo(DrawerFilterChips);
